import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissaoService } from '../services/permissao.service';
import { firstValueFrom, timer } from 'rxjs';
import { map, take } from 'rxjs/operators';

/**
 * Guard de permissão para uso nas rotas.
 *
 * Uso no routes.ts:
 *
 *   canActivate: [authGuard, permissaoGuard(['logistica.remessas:find_all'])]
 *
 * O item aparece no menu E a rota fica bloqueada para quem não tem permissão,
 * impedindo acesso direto pela URL.
 */
export function permissaoGuard(chaves: string[]): CanActivateFn {
  return async () => {
    const permissaoService = inject(PermissaoService);
    const router = inject(Router);

    if (!permissaoService.carregado()) {
      await firstValueFrom(
        timer(0, 50).pipe(
          map(() => permissaoService.carregado()),
          take(100)
        )
      );
    }

    if (permissaoService.hasAnyPermission(chaves)) {
      return true;
    }

    router.navigate(['/acesso-negado']);
    return false;
  };
}